import React from 'react';

export function Loader() {
  return (
    <div className="fixed inset-0 z-[9999] bg-nestlent-charcoal flex items-center justify-center transition-opacity duration-600">
      <div className="text-center animate-[fadeUp_0.4s_ease_forwards]">
        <div className="font-brand text-[2.8rem] text-white tracking-[0.15em]">
          NEST<span className="text-nestlent-green-mid">LENT</span>
        </div>
        <div className="text-[0.6rem] font-light tracking-[0.3em] uppercase text-white/40 mt-2">
          Where Happiness Resides
        </div>
        <div className="loader-bar-anim h-px bg-nestlent-green-mid mx-auto mt-5" />
      </div>
    </div>
  );
}
